import React from 'react';
import '../../assets/scss/signup.scss';
import fire from '../../config/firebase';
import Form from "../small-components/login/login";
import { Alert, AlertTitle } from "@material-ui/lab";
import {
  Grid,
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: false,
      passwordReset: false
    };
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  login(e, key) {
    e.preventDefault();
    const th = this;
    this.setState({
      password: key
    });

    fire.auth().signInWithEmailAndPassword(this.state.email, key).then(() => {
      this.props.history.push("/dashboard")
    }).catch((err) => {
      console.log(err);
      th.setState({
        error: true
      });
    });
  }

  forgotPassword = (e) => {
    e.preventDefault();
    const th = this;
    fire.auth().sendPasswordResetEmail(this.state.email)
      .then(function () {
        th.setState({
          passwordReset: true
        });
      }).catch(function (e) {
        console.log(e)
      })
  }
  closeAlert = () => {
    this.setState({
      error: false,
      passwordReset: false
    })
  }
  render() {
    return (
      <React.Fragment>
        <Grid item xs className="error" style={this.state.error ? { 'display': 'block' } : { 'display': 'none' }}>
          <Alert onClose={this.closeAlert} severity="error">
            <AlertTitle style={{ fontWeight: 100 }}>Incorrect email or password</AlertTitle>
          </Alert>
        </Grid>
        {/*<h5 className="error" style={this.state.error?{'display':'block'}:{'display':'none'}}>You Entered the wrong Email ID and Password</h5>*/}
        <Grid item xs className="forget-pass-alert" style={this.state.passwordReset ? { 'display': 'block' } : { 'display': 'none' }}>
          <Alert onClose={this.closeAlert} severity="info">
            <AlertTitle style={{ fontWeight: 300 }}>Please check your email</AlertTitle>
          </Alert>
        </Grid>
        <Form error={this.state.error} submit={this.login} change={this.handleChange} forget={this.forgotPassword} />
      </React.Fragment>
    )
  }
}

export default withRouter(LoginPage);